/// <reference types="web-bluetooth" />
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { sleep } from "../../common";
import { PEN_PACKET_START, PEN_PACKET_END, PEN_SERVICE_UUID_16, PEN_CHARACTERISTICS_WRITE_UUID_16, PEN_CHARACTERISTICS_NOTIFICATION_UUID_16, PEN_SERVICE_UUID_128, PEN_CHARACTERISTICS_WRITE_UUID_128, PEN_CHARACTERISTICS_NOTIFICATION_UUID_128, } from "./pencomm_const";
import { escapePenPacket, unescapePacket } from "./pen_util_func";
// npm install -D @types/web-bluetooth
export function deviceSelectDlg() {
    return __awaiter(this, void 0, void 0, function* () {
        console.log("********* Requesting any Bluetooth Device... **********");
        const options = {
            // acceptAllDevices: true,
            filters: [
                { services: [PEN_SERVICE_UUID_16, PEN_SERVICE_UUID_128] },
                // { services: [PEN_SERVICE_UUID_128] },
                { namePrefix: "Neosmartpen" },
                { namePrefix: "LAMY" },
                { namePrefix: "Smartpen" },
                { namePrefix: "RED1" },
                { namePrefix: "RED2" },
                { namePrefix: "BLUE1" },
                { namePrefix: "BLUE2" },
                { namePrefix: "Pio" },
                { namePrefix: "NPEN" },
            ]
        };
        // let result = await Bluetooth.requestDeviceAsync(options);
        let result = { device: null, type: "null" };
        try {
            // let mobileNavigatorObject: any = window.navigator;
            const device = yield navigator.bluetooth.requestDevice(options);
            result = { type: 'success', device };
        }
        catch (error) {
            if (error.code === 8) {
                // User Cancelled
                result = { device: null, type: 'cancel' };
            }
            throw error;
        }
        if (result.type === 'cancel') {
            return null;
        }
        return result.device;
    });
}
var DEVICE_STATE;
(function (DEVICE_STATE) {
    DEVICE_STATE[DEVICE_STATE["disconnected"] = 0] = "disconnected";
    DEVICE_STATE[DEVICE_STATE["connecting"] = 1] = "connecting";
    DEVICE_STATE[DEVICE_STATE["connected"] = 2] = "connected";
})(DEVICE_STATE || (DEVICE_STATE = {}));
const PEN_BT_UUID = {
    // for F30, and future devices
    "new": {
        service: PEN_SERVICE_UUID_128,
        write: PEN_CHARACTERISTICS_WRITE_UUID_128,
        noti: PEN_CHARACTERISTICS_NOTIFICATION_UUID_128,
    },
    // for F51, F50, F121, F120
    "old": {
        service: PEN_SERVICE_UUID_16,
        write: PEN_CHARACTERISTICS_WRITE_UUID_16,
        noti: PEN_CHARACTERISTICS_NOTIFICATION_UUID_16,
    }
};
export class PenCommBase {
    /**
     *
     * @param protocolHandler
     */
    constructor(protocolHandler) {
        this.protocolHandler = null;
        this.btDevice = null;
        this._btWriteSocket = null;
        this._btNotifyIndicate = null;
        // this._bluetooth_MTU = 1024;
        this._bt_buffer = new Uint8Array(0);
        // this.modelNameString = null;
        this.inConnecting = false;
        this.inDisconnecting = false;
        this.connected = false;
        this._state = DEVICE_STATE.disconnected;
        this.btServer = null;
        this.wait = (ms) => {
            let timerId = 0;
            let resolve = undefined;
            const pr = new Promise((r, j) => {
                timerId = window.setTimeout(() => {
                    resolve = r;
                    r(0);
                }, ms);
            });
            return { promise: pr, timerId, resolve };
        };
        this.getBLEService = (svcUuid, server, timeout = 5000) => __awaiter(this, void 0, void 0, function* () {
            const waitUnit = 50;
            let isError = false;
            let service = null;
            isError = false;
            const servicePromise = server.getPrimaryService(svcUuid);
            servicePromise.then((s) => {
                console.log(`          FOUND`);
                service = s;
            }).catch((e) => {
                console.log(`          NOT FOUND ${svcUuid}`);
                isError = true;
            });
            for (let i = 0, ln = Math.floor(timeout / waitUnit); i < ln && (!service) && (!isError); i++) {
                yield sleep(waitUnit);
            }
            if (!service) {
                throw new Error(`finding the service timed out ${svcUuid}`);
            }
            if (isError) {
                throw new Error(`the service not found ${svcUuid}`);
            }
            return service;
        });
        this.getBLECharacteristic = (charUuid, service, timeout = 5000) => __awaiter(this, void 0, void 0, function* () {
            const waitUnit = 50;
            let isError = false;
            let characteristic = null;
            const charPromise = service.getCharacteristic(charUuid);
            charPromise.then((c) => {
                console.log(`          FOUND`);
                characteristic = c;
            }).catch((e) => {
                console.log(`          NOT FOUND ${charUuid}`);
                isError = true;
            });
            for (let i = 0, ln = Math.floor(timeout / waitUnit); i < ln && (!characteristic) && (!isError); i++) {
                yield sleep(waitUnit);
            }
            if (!characteristic) {
                throw new Error(`finding the characteristic timeout ${charUuid}`);
            }
            if (isError) {
                throw new Error(`finding the characteristic timeout ${charUuid}`);
            }
            return characteristic;
        });
        /**
         *
         * @param server
         */
        this.getService = (server) => __awaiter(this, void 0, void 0, function* () {
            let uuids = [PEN_BT_UUID.old, PEN_BT_UUID.new];
            if (server.device.name === "Smartpen dimo_d") {
                uuids = [PEN_BT_UUID.new, PEN_BT_UUID.old];
            }
            try {
                const result = yield this.getServiceProcess(uuids[0], server);
                return result;
            }
            catch (e) {
                try {
                    console.log(`  ==> retry`);
                    const result = yield this.getServiceProcess(uuids[1], server);
                    return result;
                }
                catch (e) {
                    console.log(`  ==> finally failed`);
                    throw e;
                }
            }
        });
        /**
         *
         * @param btDevice
         * @param protocolStartCallback
         */
        this.connect = (btDevice, protocolStartCallback) => __awaiter(this, void 0, void 0, function* () {
            if (this._state !== DEVICE_STATE.disconnected) {
                return {
                    status: "already connected",
                    success: false
                };
            }
            this.connected = false;
            this.inConnecting = true;
            let server = null;
            this.btServer = server;
            // step 1, physically connection
            try {
                console.log("1. Connecting to GATT Server...");
                btDevice.addEventListener("gattserverdisconnected", this.onDeviceDisconnected);
                server = yield btDevice.gatt.connect();
            }
            catch (e) {
                btDevice.removeEventListener("gattserverdisconnected", this.onDeviceDisconnected);
                let status = "cannot connect GATT server on the pen";
                const isBTdevice = e.message.indexOf("adapter");
                if (isBTdevice > -1)
                    status = "Bluetooth LE dongle is not found";
                return {
                    status,
                    success: false
                };
            }
            // step 2
            let writeSocket = null;
            let notifyIndicate = null;
            try {
                console.log(`2. get Service and Sockets, connected:${server.connected}`);
                const ret = yield this.getService(server);
                writeSocket = ret.writeSocket;
                notifyIndicate = ret.notifyIndicate;
                console.log("3. Add Event listeners");
                if (notifyIndicate) {
                    notifyIndicate.addEventListener("characteristicvaluechanged", this.onPenPacketReceived);
                }
                else {
                    return {
                        status: "cannot listen eventes on notify indicator",
                        success: false
                    };
                }
            }
            catch (e) {
                return {
                    status: "cannot find services on pen",
                    success: false
                };
            }
            try {
                console.log("4. Start getting notifications");
                yield notifyIndicate.startNotifications();
            }
            catch (e) {
                let status = "cannot start getting notifications";
                const isBTdevice = e.message.indexOf("adapter");
                if (isBTdevice > -1)
                    status = "Bluetooth LE dongle is not found";
                return {
                    status,
                    success: false,
                };
            }
            this.btDevice = btDevice;
            this._btWriteSocket = writeSocket;
            this._btNotifyIndicate = notifyIndicate;
            console.log("BLE Connected...");
            this.connected = true;
            this.inConnecting = false;
            protocolStartCallback();
            // this.protocolHandler.onPhysicallyConnected();
            return {
                status: "connnection initiated",
                success: true,
            };
        });
        /**
         * disconnect function:
         */
        this.disconnect = () => {
            console.log(`     DISCONNECT operation`);
            this.inDisconnecting = true;
            const self = this;
            if (!self.connected || self.btDevice === null) {
                return;
            }
            if (self.btDevice !== null) {
                self.btDevice.gatt.disconnect();
            }
        };
        /**
         *
         */
        this.preDisconnected = () => {
            throw new Error("Not implemented: preDisconnected");
        };
        /**
         *
         */
        this.onDeviceDisconnected = () => {
            this.inDisconnecting = false;
            this.btDevice = null;
            this.btServer = null;
            this._btWriteSocket = null;
            this._btNotifyIndicate = null;
            this._bt_buffer = new Uint8Array(0);
            // 상위로 전달
            const handler = this.protocolHandler;
            if (handler)
                handler.onDisconnected();
            // this.protocolHandler = null;
        };
        /**
         *
         * @param unescaped
         */
        this.writeArray = (arr) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const len = arr.length;
            const bf = escapePenPacket(arr.slice(1, len - 1));
            bf.unshift(arr[0]);
            bf.push(arr[len - 1]);
            const escaped = new Uint8Array(bf);
            let reqSuccess = false;
            let reqRestCnt = 6;
            while (!reqSuccess && reqRestCnt > 0) {
                // const unescaped = new Uint8Array(arr);
                try {
                    // await this._btWriteSocket?.writeValue(unescaped);
                    yield ((_a = this._btWriteSocket) === null || _a === void 0 ? void 0 : _a.writeValue(escaped));
                    reqSuccess = true;
                }
                catch (e) {
                    yield sleep(50);
                    reqRestCnt--;
                }
            }
            return reqSuccess;
        });
        this.write = (buf) => __awaiter(this, void 0, void 0, function* () {
            const arr = Array.from(buf);
            return yield this.writeArray(arr);
            // const len = arr.length;
            // const bf = escapePenPacket(arr.slice(1, len - 1));
            // const escaped = new Uint8Array([arr[0], ...bf, arr[len - 1]]);
            // try {
            //   await this._btWriteSocket?.writeValue(escaped);
            //   return true;
            // }
            // catch (e) {
            //   return false;
            // }
        });
        /**
         * PEN PACKET PROCESSOR
         *
         * process raw packets from pen
         * slice packets in to a unit packet
         * process the unit packet command code
         * @param event
         */
        this.onPenPacketReceived = (event) => {
            // console.log("    handle Data");
            const value = event.target.value;
            const data_length = event.target.value.byteLength;
            // 이전에 있던 buf에 concatenate
            const prev_buf = this._bt_buffer;
            const prev_len = prev_buf.length;
            let buffer = new Uint8Array(prev_buf.length + data_length);
            // https://stackoverflow.com/questions/14071463/how-can-i-merge-typedarrays-in-javascript
            buffer.set(prev_buf);
            for (let i = 0; i < value.byteLength; i++) {
                buffer[prev_len + i] = value.getUint8(i);
            }
            let start = buffer.indexOf(PEN_PACKET_START);
            let end = buffer.indexOf(PEN_PACKET_END);
            // let idx = 0;
            // let cnt = 0;
            // console.log("packet length: " + data_length);
            while (start !== -1 && end !== -1) {
                // console.log("   [" + cnt + "]  packet found: (" + (idx + start) + ", " + (idx + end) + ")");
                // buffer 잘라 주기
                const curCmdPacket = buffer.slice(start, end + 1);
                // idx += end;
                // escape code 처리
                const unescapedBuf = unescapePacket(curCmdPacket);
                // packet 처리
                if (unescapedBuf[0] === PEN_PACKET_START) {
                    // pen command 처리
                    this.protocolHandler.processUnitPacket(unescapedBuf);
                }
                else {
                    // 위의 slice 처리가 이상하든지 메모리가 깨졌다.
                }
                // buffer 정리
                // cnt++;
                buffer = buffer.slice(end + 1);
                start = buffer.indexOf(PEN_PACKET_START);
                end = buffer.indexOf(PEN_PACKET_END);
            }
            this._bt_buffer = buffer;
        };
        this.protocolHandler = protocolHandler;
    }
    /**
     *
     * @param uuid
     * @param server
     */
    getServiceProcess(uuid, server) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log(`  2-1. getting the primary service,             uuid:${uuid.service}, connected:${server.connected}`);
            const service = yield this.getBLEService(uuid.service, server, 5000);
            console.log(`  2-2. getting the write characteristic,        uuid:${uuid.write}, connected:${server.connected}`);
            const writeSocket = yield this.getBLECharacteristic(uuid.write, service, 5000);
            console.log(`  2-3. getting the notification characteristic, uuid:${uuid.noti}, connected:${server.connected}`);
            const notifyIndicate = yield this.getBLECharacteristic(uuid.noti, service, 5000);
            return { service, writeSocket, notifyIndicate };
        });
    }
}
// export abstract class ProtocolHandlerBase {
//   onPhysicallyConnected: () => void;
//   onDisconnected: () => void;
//   processUnitPacket: () => void;
// }
//# sourceMappingURL=pencomm_base.js.map